import getStore from './getStore';
import setStore from './setStore';

export {
  getStore,
  setStore
};